import { useQuery } from '@tanstack/react-query';
import ClientConfigService from '@utility/services/client-config';

export const useClientConfig = () => {
  return useQuery({
    queryKey: ['clientConfig'],
    queryFn: () => ClientConfigService.get(),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
